<template>
  <a-input ref="input"
           :value="innerValue"
           v-bind="cellProps"
           @click="openLang(originColumn.field)"
           @blur="handleBlur"
           @change="handleChange" />
</template>

<script>
import { JVXETypes } from '@/components/jeecg/JVxeTable'
import JVxeCellMixins from '@/components/jeecg/JVxeTable/mixins/JVxeCellMixins'
import { mapGetters } from 'vuex'
import { queryFiledLanguageList } from '@api/api'
import { getLangFieldDetail, openLangInputModal, setSubInputParams } from '@/utils/langUtils'

const NumberRegExp = /^-?\d+\.?\d*$/
export default {
  name: 'JVxeInputCell',
  mixins: [JVxeCellMixins],
  methods: {
    // 判断是否为数据多语言字段，是则readonly设为true
    checkField(field) {
      return this.subLangField.includes(field)
    },
    // 打开数据多语言录入模态框
    async openLang(field) {
      if (!this.checkField(field)) return
      let { subTableName } = this.renderOptions
      // 根据业务id和表名、字段获取本地缓存这种的多语言数组
      let arr = setSubInputParams({ subTableName, field, list: this.row?.sysLanguageList })
      console.log(arr, '子表自我编辑获取', subTableName)
      let fieldObj = {
        field,
        detail: arr,
        id: this.row.id,
        require: true,
        tableName: subTableName
      }
      // 详情才会调接口获取
      if (this.row?.id) {
        // 判断本地缓存中如果没有则调用接口
        if (!arr || !arr.length) {
          let res = await getLangFieldDetail({ field, id: this.row.id, tableName: subTableName })
          fieldObj.detail = res
        }
      }
      // 打开数据多语言录入模态框
      openLangInputModal(fieldObj, (data, content) => this.langInputSubmit(data, content), 'children')
    },
    // 数据多语言录入数据后回调
    langInputSubmit({ value }, { langArr }) {
      // 给表单设置值
      this.handleChangeCommon(value)
      // 把数据多语言设置到当前行数据
      this.row.sysLanguageList = [...langArr]
    },
    /** 处理change事件 */
    handleChange(event) {
      let { $type } = this
      let { target } = event
      let { value, selectionStart } = target
      let change = true
      if ($type === JVXETypes.inputNumber) {
        // 判断输入的值是否匹配数字正则表达式，不匹配就还原
        if (!NumberRegExp.test(value) && (value !== '' && value !== '-')) {
          change = false
          value = this.innerValue
          target.value = value || ''
          if (typeof selectionStart === 'number') {
            target.selectionStart = selectionStart - 1
            target.selectionEnd = selectionStart - 1
          }
        }
      }
      // 触发事件，存储输入的值
      if (change) {
        this.handleChangeCommon(value)
      }

      if ($type === JVXETypes.inputNumber) {
        // this.recalcOneStatisticsColumn(col.key)
      }
    },

    /** 处理blur失去焦点事件 */
    handleBlur(event) {
      let { $type } = this
      let { target } = event
      // 判断输入的值是否匹配数字正则表达式，不匹配就置空
      if ($type === JVXETypes.inputNumber) {
        if (!NumberRegExp.test(target.value)) {
          target.value = ''
        } else {
          target.value = Number.parseFloat(target.value)
        }
        this.handleChangeCommon(target.value)
      }

      this.handleBlurCommon(target.value)
    }

  },
  // 【组件增强】注释详见：JVxeCellMixins.js
  enhanced: {
    installOptions: {
      // 自动聚焦的 class 类名
      autofocus: '.ant-input'
    },
    getValue(value) {
      if (this.$type === JVXETypes.inputNumber && typeof value === 'string') {
        if (NumberRegExp.test(value)) {
          return Number.parseFloat(value)
        }
      }
      return value
    }
  }
}
</script>

<style scoped>

</style>